import React from "react";
import "./About.css";

function About() {
  return (
    <div className="about__container">
      <span>hi</span>
      <span>son</span>
    </div>
  );
}

export default About;
